import React from "react";
import { render } from "react-dom";

import Auth from "widgets/Auth";

render(
  <Auth />,
  document.getElementById("js-root"),
);
